import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { DropdownContext } from './dropdownConstants';
export var DropdownGroup = function DropdownGroup(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$label = _a.label,
      label = _a$label === void 0 ? '' : _a$label,
      props = __rest(_a, ["children", "className", "label"]);

  return React.createElement(DropdownContext.Consumer, null, function (_ref) {
    var sectionClass = _ref.sectionClass,
        sectionTitleClass = _ref.sectionTitleClass,
        sectionComponent = _ref.sectionComponent;
    var SectionComponent = sectionComponent;
    return React.createElement(SectionComponent, Object.assign({
      className: css(sectionClass, className)
    }, props), label && React.createElement("h1", {
      className: css(sectionTitleClass),
      "aria-hidden": true
    }, label), React.createElement("ul", {
      role: "none"
    }, children));
  });
};
DropdownGroup.displayName = 'DropdownGroup';